<template>
	<!-- 门店档案 -->
	<div style="father">
		<div style="margin-bottom: 15px;">
			<el-form>
			</el-form>
			<el-date-picker @change="handleChange()" v-model="query.time" type="daterange" value-format="yyyy-MM-dd"
				size="small"></el-date-picker>
			<el-select @change="handleChange()" v-model="query.storeId" placeholder="全部门店" clearable
				style="margin-left: 10px;" size="small">
				<el-option-group label="营业门店" class="store">
					<el-option v-for="item in storeList" :key="item.id" :label="item.title" :value="item.id">
					</el-option>
				</el-option-group>
				<el-option-group label="结业门店">
					<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
					</el-option>
				</el-option-group>
			</el-select>
			<el-button @click="reLoad()" style="margin-left: 10px;" size="small">重置</el-button>
			<el-button @click="expore()" style="margin-left: 10px;" type="primary" size="small">导出</el-button>
		</div>
		<div style="text-align: center;">
			<el-table style="text-align: center;" :cell-style="{'text-align': 'center'}" :data="tableData"
				:header-cell-style="{'text-align': 'center','color':'#6f6f6f', 'border-color': '#dfdfdf'}" show-summary>
				<el-table-column prop="storeName" label="门店" sortable></el-table-column>
				<el-table-column prop="num" label="客数" sortable></el-table-column>
				<el-table-column label="非会员">
					<el-table-column prop="first" label="首次消费" sortable></el-table-column>
					<el-table-column prop="sheng" label="生客" sortable></el-table-column>
					<el-table-column prop="shu" label="熟客" sortable></el-table-column>
					<el-table-column prop="shendu" label="深度熟客" sortable></el-table-column>
				</el-table-column>
				<el-table-column label="会员">
					<el-table-column prop="mfirst" label="首次消费" sortable></el-table-column>
					<el-table-column prop="msheng" label="生客" sortable></el-table-column>
					<el-table-column prop="mshu" label="熟客" sortable></el-table-column>
					<el-table-column prop="mshendu" label="深度熟客" sortable></el-table-column>
				</el-table-column>
			</el-table>
		</div>
		<div style="margin-top: 10px;">
			<!-- <ve-line legend-position="center" :data="chartData" :extend="typeExted"></ve-line> -->
		</div>
	</div>
</template>

<script>
	import {
		url
	} from '../../../utils/index.js'
	export default {
		data() {
			return {
				url: url(),
				query: {
					pageNum: '',
					pageSize: '',
					storeId: '',
					time: [],
					startTime: '',
					endTime: ''
				},
				storeEnd: [],
				storeList: [],
				tableData: '',
				chartData: {
					columns: ['日期', '访问用户', '下单用户', '下单率'],
					rows: []
				}
			};
		},
		mounted() {
			this.getStores()
			this.Loading()
		},
		methods: {
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 1) {
							this.storeEnd.push(ele) //结业门店
						} else {
							this.storeList.push(ele) //营业门店
						}
					})
				})
			},
			handleChange() {
				this.getStoreData()
			},
			Loading() {
				this.initTime();
				this.getStoreData()
			},
			initTime() {
				const date1 = new Date()
				const nowDay1 =
					`${date1.getFullYear()}-${date1.getMonth() + 1 < 10 ? `0${date1.getMonth() + 1}` : date1.getMonth() + 1}-${date1.getDate() < 10 ? `0${date1.getDate()}` : date1.getDate()}`
				this.query.time.push(nowDay1); //开始时间
				this.query.time.push(nowDay1); //结束时间
			},
			getStoreData() {
				if (this.query.time != '' && this.query.time != null && this.query.time != undefined) {
					var a = {
						startTime: this.query.time[0],
						endTime: this.query.time[1],
						storeId: this.query.storeId
					}
				} else {
					var a = {
						storeId: this.query.storeId
					}
				}
				this.$http.post("dbarrel/storeData", JSON.stringify(a)).then(res => {
					if (res.body.code == 200 && res.body.data != '') {
						this.tableData = res.body.data
						this.chartData
					}
				})
			},
			reLoad() {
				const date1 = new Date()
				const nowDay1 =
					`${date1.getFullYear()}-${date1.getMonth() + 1 < 10 ? `0${date1.getMonth() + 1}` : date1.getMonth() + 1}-${date1.getDate() < 10 ? `0${date1.getDate()}` : date1.getDate()}`
				this.query = {
					pageNum: '',
					pageSize: '',
					storeId: '',
					time: [],
					startTime: '',
					endTime: ''
				};
				this.query.time.push(nowDay1); //开始时间
				this.query.time.push(nowDay1); //结束时间
				this.getStoreData()
			},
			// 导出
			expore() {
				if (this.query.time != null) {
					var s = this.query.time[0];
					var e = this.query.time[1];
				} else {
					var s = '';
					var e = '';
				}
				var a = "?startTime=" + s + "&endTime=" + e + "&storeId=" + this.query.storeId
				window.location.assign(this.url + "dbarrel/exporeStoreData" + a)
			}
		}
	}
</script>

<style>
	.el-table__footer-wrapper tbody td,
	.el-table__header-wrapper tbody td {
		text-align: center;
	}
	/deep/.el-select-dropdown__item {
		width:220px;
	}
</style>